<!-- {{ data }} -->
@if (showSpinner) {
  <app-loader> </app-loader>
}

<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid">
    <!-- payroll details -->
    <div class="attendance-time-section">
      <div class="row">
        <div class="col-sm-6 col-md-4 col-xl-3 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Month</h1>
            <h1>{{salary_detail.month_char}}</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Total Salary
              {{ salary_detail.user.salary_type === 'hourly' ? 'Per Hour' : (salary_detail.user.salary_type ===
              'monthly' ?
              'Per
              Monthly' :
              'Monthly') }}
            </h1>
            <h1>{{salary_detail.basic_salary}}/-</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Deduction</h1>
            <h1>{{salary_detail.total_deduction === null ? "00" : salary_detail.total_deduction}}/-</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3 timer">
          <div class="timer-inner my-2" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
            <h1>This Month Salary</h1>
            <h1>{{salary_detail.released_salary === null ? "00" : salary_detail.released_salary}}/-</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- payroll details table-->
    <div class="detail-table my-4" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="salary-calculation">
        <div class="salary-calculation-header top-table-header py-3 text-center"
          [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
          <h1>Salary Calculation for the month of {{salary_detail.month_char}} {{salary_detail.month_year}}
          </h1>
        </div>
        <div class="salary-calculation-header-table">
          <div class="row">
            <div class="col-md-6">
              <table [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                <tr>
                  <td>Employee Code:</td>
                  <td>{{user_detail.attendance_user_id}}</td>
                </tr>
                <tr>
                  <td>Employee Name:</td>
                  <td>{{user_detail.first_name}} {{user_detail.last_name}}</td>
                </tr>
                <tr>
                  <td>Designation:</td>
                  <td>{{user_detail.description}}</td>
                </tr>
                <tr>
                  <td>Department:</td>
                  <td>{{user_detail.department}}</td>
                </tr>

              </table>
            </div>
            <div class="col-md-6">
              <table class="mt-4 mt-md-0" [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                <tr>
                  <td>Date of Joining:</td>
                  <td>{{user_detail.joining_date === null ? "" : user_detail.joining_date}}</td>
                </tr>
                <tr>
                  <td>CNIC:</td>
                  <td>{{user_detail.cnic}}</td>
                </tr>
                <tr>
                  <td>Employment Type:</td>
                  <td>{{user_detail.employee_type}}</td>
                </tr>
                <tr>
                  <td>Employment Status:</td>
                  <td>{{user_detail.employee_status}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="salary-calculation mt-4">
        <div class="salary-calculation-header-table">
          <div class="row">
            <div class="col-md-6">
              <div class="salary-calculation-header py-3 text-center"
                [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
                <h1>Actual Details</h1>
              </div>
              <table [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Absent’s</td>
                    <td>{{salary_detail.absents === null ? "0" : salary_detail.absents}}</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Un Paid Leaves</td>
                    <td>{{salary_detail.unpaid_leaves === null ? "0" : salary_detail.unpaid_leaves}}
                    </td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Paid Leaves</td>
                    <td>{{salary_detail.paid_leaves === null ? "0" : salary_detail.paid_leaves}}</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Late Check In (Hours)</td>
                    <td>{{salary_detail.late_check_in === null ? "0" : salary_detail.late_check_in}}
                    </td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Short Hours</td>
                    <td>{{salary_detail.short_hours === null ? "0" : salary_detail.short_hours}}</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Over Time (Hours)</td>
                    <td>{{salary_detail.overtime_hours === null ? "0" : salary_detail.overtime_hours}}
                    </td>
                  </tr>
                }
                @if (salary_detail.user.salary_type === 'hourly') {
                  <tr class="total-hours">
                    <td>Total Hour Work</td>
                    <td>
                      {{ salary_detail.total_worked_hours ?? "0" }}
                    </td>
                  </tr>
                }

              </table>
            </div>
            <div class="col-md-6">
              <div class="salary-calculation-header py-3 text-center mt-4 mt-md-0"
                [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
                <h1>Effactive Ammount Details</h1>
              </div>
              <table [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Absent’s</td>
                    <td>{{salary_detail.absents_amount === null ? "00" :
                    salary_detail.absents_amount}}/-</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Un Paid Leaves</td>
                    <td>{{salary_detail.unpaid_leaves_amount === null ? "00" :
                    salary_detail.unpaid_leaves_amount}}/-</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Paid Leaves</td>
                    <td>00/-</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Late Check In (Hours)</td>
                    <td>{{salary_detail.late_check_in_amount === null ? "00" :
                    salary_detail.late_check_in_amount}}/-</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Short Hours</td>
                    <td>{{salary_detail.short_hours_amount === null ? "00" :
                    salary_detail.short_hours_amount}}/-</td>
                  </tr>
                }
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Over Time (Hours)</td>
                    <td>{{salary_detail.overtime_amount === null ? "00" :
                    salary_detail.overtime_amount}}/-</td>
                  </tr>
                }

                @if (salary_detail.user.salary_type === 'hourly') {
                  <tr>
                    <td>Total Salary Amount</td>
                    <td>
                      {{
                      salary_detail.total_worked_hours
                      * salary_detail.basic_salary
                      }}/-
                    </td>
                  </tr>
                }

              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="salary-calculation mt-4">
        <div class="salary-calculation-header-table">
          <div class="row">
            <div class="col-md-6">
              <div class="salary-calculation-header py-3 text-center"
                [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
                <h1>Final Details</h1>
              </div>
              <table [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                <tr>
                  <td>Total {{ salary_detail.user.salary_type === 'hourly' ? 'Per Hour' :
                    (salary_detail.user.salary_type ===
                    'monthly' ?
                    'Per
                    Monthly' :
                  'Monthly') }} Salary</td>
                  <td>{{salary_detail.basic_salary}}/-</td>
                </tr>
                @if (salary_detail.user.salary_type !== 'hourly') {
                  <tr>
                    <td>Total Deductions</td>
                    <td>{{salary_detail.total_deduction === null ? "00" :
                    salary_detail.total_deduction}}/-</td>
                  </tr>
                }
                <tr>
                  <td>Tax on Salary</td>
                  <td>{{salary_detail.tax === null ? "00" : salary_detail.tax}}/-</td>
                </tr>
                <tr>
                  <td>Final Received Salary</td>
                  <td class="final-salary">{{salary_detail.released_salary === null ? "00" :
                  salary_detail.released_salary}}/-</td>
                </tr>

              </table>
            </div>
            <div class="col-md-6">
              <div class="salary-calculation-header py-3 text-center mt-4 mt-md-0"
                [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
                <h1>Other Adjustments</h1>
              </div>
              <table [ngClass]="{ 'dark-table': selectedMode === 'dark' }">
                <tr>
                  <td>Advance Amount</td>
                  <td> {{salary_detail.advance_payment === null ? "00" :
                  salary_detail.advance_payment}}/-</td>
                </tr>
                <tr>
                  <td>compansations Amount</td>
                  <td> {{salary_detail.compensation_amount === null ? "00" :
                  salary_detail.compensation_amount}}/-</td>
                </tr>
                <tr>
                  <td>Other Deduction</td>
                  <td> {{salary_detail.other_deduction === null ? "00" :
                  salary_detail.other_deduction}}/-</td>
                </tr>
                @if (salary_detail.loan_deduction_amount != null) {
                  <tr>
                    <td>Loan Deduction</td>
                    <td> {{salary_detail.loan_deduction_amount === null ? "00" :
                    salary_detail.loan_deduction_amount}}/-</td>
                  </tr>
                }


              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 print-btn text-center mb-4 py-md-5 my-2">
        <button (click)="printPage()" data-html2canvas-ignore="true">Print Pay Slip</button>
      </div>

    </div>
  </div>
</main>

<!-- for print and download -->
<div id="salary-slip" style=" display: none; max-width: 968px;">
  <div class="row" style="max-width: 968px; display: flex;">
    <div style="padding-top: 33px; width: 100%;">
      <span class="font-weight-bold" style="color: #5069a1 !important; font-size: 35px;">Work Insight</span>
      <p><small class="font-weight-bold" style="color: #5069a1 !important;">46-K, DHA Phase 1, Lahore
      Pakistan</small></p>
    </div>
    <div style="margin-bottom: 5px !important; padding-top: 27px;">
      <img src="assets/login/Logo.png" width="200px" height="80px">
    </div>
  </div>
  <div class="row" style="font-size: 12px !important;">
    <div style="width: 100%;">
      <div style="position: relative;
                                        display: flex;
                                        flex-direction: column;
                                        min-width: 0;
                                        word-wrap: break-word;
                                        background-color: #fff;
                                        background-clip: border-box;">
        <div style="border-radius: .25rem!important;">
          <div>
            <div style="display: flex;
                                flex: 1 1 auto;
                                min-height: 1px;
                                padding: 1.25rem;
                                border-top-left-radius: .25rem!important;
                                border-top-right-radius: .25rem!important;
                                background-color: #112A5F;
                                align-items: flex-start;
                                text-align: center;
                                color: white;
                                font-weight: bold;
                                font-style: italic;">
              <div style="flex-basis: 0; flex-grow: 1; width: 100%;">
                <span style="font-size: 20px; font-family: Arial, Helvetica, sans-serif;">Salary
                  Calculation for the month of {{salary_detail.month_char}}
                {{salary_detail.month_year}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row" style="display: flex;">
        <div class="" style="width: 49%;">
          <table
            style="display: table; box-sizing: border-box; text-indent: initial; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
            <thead>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Employee Code:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.attendance_user_id}}</td>
              </tr>
            </thead>
            <tbody>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Employee Name:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.first_name}}
                {{user_detail.last_name}}</td>
              </tr>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Designation:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.description}}</td>
              </tr>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Department:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.department}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="" style="width: 49%; margin-left: 2%;">
          <table
            style="display: table; box-sizing: border-box; text-indent: initial; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
            <thead>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Date of Joining:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.joining_date === null ? "" :
                user_detail.joining_date}}</td>
              </tr>
            </thead>
            <tbody>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">CNIC:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.cnic}}</td>
              </tr>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Employment Type:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.employee_type}}</td>
              </tr>
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Employment Status:</th>
                <td style="border: inherit; padding: .75rem;">{{user_detail.employee_status}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>


  <div class="row" style="display: flex;">
    <div style="width: 49%;">
      <div class="">
        <div style="position: relative;
                        display: flex;
                        flex-direction: column;
                        min-width: 0;
                        word-wrap: break-word;
                        background-color: #fff;
                        background-clip: border-box;">
          <div style="border-radius: .25rem!important;">
            <div style="display: flex;
                                        flex: 1 1 auto;
                                        min-height: 1px;
                                        padding-top: 1.25rem;
                                        padding-bottom: 1.25rem;
                                        border-top-left-radius: .25rem!important;
                                        border-top-right-radius: .25rem!important;
                                        background-color: #112A5F;
                                        align-items: flex-start;
                                        text-align: center;
                                        color: white;
                                        font-weight: bold;
                                        max-width: 100%;
                                        font-style: italic;">
              <div style="flex-basis: 0; flex-grow: 1;">
                <span style="font-size: 20px; font-family: Arial, Helvetica, sans-serif;">Actual
                Details</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <table
            style="display: table; box-sizing: border-box; text-indent: initial; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
            <tbody>

              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;"> Absent's</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.absents === null ? "0" :
                  salary_detail.absents}}</td>
                </tr>
              }

              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Un Paid Leaves</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.unpaid_leaves === null ?
                  "0" : salary_detail.unpaid_leaves}}</td>
                </tr>
              }

              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Paid Leaves</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.paid_leaves === null ? "0"
                  : salary_detail.paid_leaves}}</td>
                </tr>
              }


              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Late Check In (Hours)</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.late_check_in === null ?
                  "0" : salary_detail.late_check_in}}</td>
                </tr>
              }
              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Short Hours</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.short_hours === null ? "0"
                  : salary_detail.short_hours}}</td>
                </tr>
              }
              @if (salary_detail.user.salary_type !== 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Over Time (Hours)</th>
                  <td style="border: inherit; padding: .75rem;">{{salary_detail.absents === null ? "0" :
                  salary_detail.absents}}</td>
                </tr>
              }
              @if (salary_detail.user.salary_type === 'hourly') {
                <tr style="border: 1px solid #dee2e6 !important;">
                  <th style="border: inherit; padding: .75rem;">Total Hour Work</th>
                  <td style="border: inherit; padding: .75rem;">{{ salary_detail.total_worked_hours ?? "0" }}</td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div style=" width: 49%; margin-left: 2%;">
      <div style="position: relative;
                            word-wrap: break-word;
                            background-color: #fff;
                            background-clip: border-box;">
        <div style="border-radius: .25rem!important;">
          <div style="display: flex;
                                    flex: 1 1 auto;
                                    min-height: 1px;
                                    padding: 1.25rem;
                                    border-top-left-radius: .25rem!important;
                                    border-top-right-radius: .25rem!important;
                                    background-color: #112A5F;
                                    align-items: flex-start;
                                    text-align: center;
                                    color: white;
                                    font-weight: bold;
                                    font-style: italic;">
            <div style="flex-basis: 0; flex-grow: 1;">
              <span style="font-size: 20px; font-family: Arial, Helvetica, sans-serif;">Effactive Ammount
              Details </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table
          style="display: table; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
          <tbody>

            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Absent's</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.absents_amount === null ? "00"
                : salary_detail.absents_amount}}/-</td>
              </tr>
            }

            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Un Paid Leaves</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.unpaid_leaves_amount === null
                ? "00" : salary_detail.unpaid_leaves_amount}}/-</td>
              </tr>
            }

            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Paid Leaves</th>
                <td style="border: inherit; padding: .75rem;">00/-</td>
              </tr>
            }


            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Late Check In (Hours)</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.late_check_in_amount === null
                ? "00" : salary_detail.late_check_in_amount}}/-</td>
              </tr>
            }
            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Short Hours</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.short_hours_amount === null ?
                "00" : salary_detail.short_hours_amount}}/-</td>
              </tr>
            }
            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Over Time (Hours)</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.overtime_amount === null ?
                "00" : salary_detail.overtime_amount}}/-</td>
              </tr>
            }
            @if (salary_detail.user.salary_type === 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Total Salary Amount</th>
                <td style="border: inherit; padding: .75rem;">{{
                  salary_detail.total_worked_hours
                  * salary_detail.basic_salary
                }}/-</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>


  <div class="row" style="display: flex;">
    <div style=" width: 49%;">
      <div style="position: relative;
                            display: flex;
                            flex-direction: column;
                            min-width: 0;
                            word-wrap: break-word;
                            background-color: #fff;
                            background-clip: border-box;">
        <div style="border-radius: .25rem!important;">
          <div style="display: flex;
                                    flex: 1 1 auto;
                                    min-height: 1px;
                                    padding: 1.25rem;
                                    border-top-left-radius: .25rem!important;
                                    border-top-right-radius: .25rem!important;
                                    background-color: #112A5F;
                                    align-items: flex-start;
                                    text-align: center;
                                    color: white;
                                    font-weight: bold;
                                    font-style: italic;">
            <div style="flex-basis: 0; flex-grow: 1;">
              <span style="font-size: 20px; font-family: Arial, Helvetica, sans-serif;">Final
              Details</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table
          style="display: table; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
          <tbody>

            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Total Monthly Salary</th>
              <td style="border: inherit; padding: .75rem;">{{salary_detail.basic_salary}}/-</td>
            </tr>

            @if (salary_detail.user.salary_type !== 'hourly') {
              <tr style="border: 1px solid #dee2e6 !important;">
                <th style="border: inherit; padding: .75rem;">Total Deductions</th>
                <td style="border: inherit; padding: .75rem;">{{salary_detail.total_deduction === null ?
                "00" : salary_detail.total_deduction}}/-</td>
              </tr>
            }
            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Tax on Salary</th>
              <td style="border: inherit; padding: .75rem;">{{user_detail.monthly_tax_amount === null ?
              "00" : user_detail.monthly_tax_amount}}/-</td>
            </tr>
            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Final Received Salary</th>
              <td style="border: inherit; padding: .75rem;
                                font-weight: bold;
                                background-color: #7cf5d9;
                                text-align: center;
                                font-size: 20px;
                                    ">{{salary_detail.released_salary === null ? "00" :
                salary_detail.released_salary}}/-
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
    <div style=" width: 49%; margin-left: 2%;">
      <div style="position: relative;
                            display: flex;
                            flex-direction: column;
                            min-width: 0;
                            word-wrap: break-word;
                            background-color: #fff;
                            background-clip: border-box;">
        <div style="border-radius: .25rem!important;">
          <div style="display: flex;
                                    flex: 1 1 auto;
                                    min-height: 1px;
                                    padding: 1.25rem;
                                    border-top-left-radius: .25rem!important;
                                    border-top-right-radius: .25rem!important;
                                    background-color: #112A5F;
                                    align-items: flex-start;
                                    text-align: center;
                                    color: white;
                                    font-weight: bold;
                                    font-style: italic;">
            <div style="flex-basis: 0; flex-grow: 1;">
              <span style="font-size: 20px; font-family: Arial, Helvetica, sans-serif;">Other Adjustments
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table
          style="display: table; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border: 1px solid #dee2e6; width: 100%; margin-bottom: 1rem; color: #212529; border-collapse: collapse !important;">
          <tbody>

            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Advance Ammount</th>
              <td style="border: inherit; padding: .75rem;">
                {{salary_detail.advance_payment === null ? "00" : salary_detail.advance_payment}}/-
              </td>
            </tr>

            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Compensations Amount</th>
              <td style="border: inherit; padding: .75rem;">
                {{salary_detail.compensation_amount === null ? "00" :
                salary_detail.compensation_amount}}/-
              </td>
            </tr>

            <tr style="border: 1px solid #dee2e6 !important;">
              <th style="border: inherit; padding: .75rem;">Other Deduction</th>
              <td style="border: inherit; padding: .75rem;">
                {{salary_detail.other_deduction === null ? "00" : salary_detail.other_deduction}}/-
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
  <span style="color: red; width: 968px;">Note: All amounts and calculations are in PKR</span>
  <br />
  <span style="color: red; width: 968px;">P.S. This is computer generated slip, signature not required.</span>
  <br />
  <p style="width: 968px;"><span style="font-weight: 700;">Dated: </span> {{date | date: 'dd-MM-yyyy'}}</p>
</div>